const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

const getTagIds = (tagIds) =>
  Object.values(tagIds)
    .map((tagId) => Object.values(tagId))
    .flat();

const tagIdsWithStatus = (tagIds, status = 'delete') =>
  Object.values(tagIds)
    .map((tagId) => Object.values(tagId))
    .flat()
    .map((tagId) => tagId.migratortron)
    .filter((tagId) => tagId.status === status);

const groupIdsWithStatus = (groupIds, status = 'delete') =>
  Object.values(groupIds)
    .map((tagId) => tagId.migratortron)
    .filter((tagId) => tagId.status === status);

describe('Delete tags and groups', () => {
  describe('preview delete tags by a label', () => {
    const mock = loadRecordedMock('delete_tags_label=1_preview.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${expectedCount} tags to delete`, (done) => {
      migratortronApi.post(
        'delete/tags?label=1',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.delete).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(getTagIds(body.tagsToMigrate.tagIds)).to.have.a.lengthOf(
            expectedCount
          );

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds)
          ).to.have.a.lengthOf(expectedCount);
          done();
        }
      );
    });
  });

  describe('delete tags by a label', () => {
    const mock = loadRecordedMock('delete_tags_commit_label=1.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${expectedCount} tags to delete`, (done) => {
      migratortronApi.post(
        'delete/tags/commit?label=1',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.delete).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(getTagIds(body.tagsToMigrate.tagIds)).to.have.a.lengthOf(
            expectedCount
          );
          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds)
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsResult.deleted).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe('repeat the same delete tags by a label', () => {
    const mock = loadRecordedMock('delete_tags_commit_label=1_repeat.json');
    const expectedCount = 0;

    it(`should return no tags to delete`, (done) => {
      migratortronApi.post(
        'delete/tags/commit?label=1&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(getTagIds(body.tagsToMigrate.tagIds)).to.have.a.lengthOf(
            expectedCount
          );

          expect(body.tagsResult.deleted).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe('preview delete all tags in a project', () => {
    const mock = loadRecordedMock('delete_tags_simple_preview.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${expectedCount} tags to delete`, (done) => {
      migratortronApi.post(
        'delete/tags?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.delete).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');
          expect(getTagIds(body.tagsToMigrate.tagIds)).to.have.a.lengthOf(
            expectedCount
          );

          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds)
          ).to.have.a.lengthOf(expectedCount);
          done();
        }
      );
    });
  });

  describe('delete all tags in a project', () => {
    const mock = loadRecordedMock('delete_tags_commit_simple.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${expectedCount} tags to delete`, (done) => {
      migratortronApi.post(
        'delete/tags/commit?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.delete).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(getTagIds(body.tagsToMigrate.tagIds)).to.have.a.lengthOf(
            expectedCount
          );
          expect(
            tagIdsWithStatus(body.tagsToMigrate.tagIds)
          ).to.have.a.lengthOf(expectedCount);

          expect(body.tagsResult.deleted).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe('repeat the same delete all tags in a project', () => {
    const mock = loadRecordedMock('delete_tags_commit_simple_repeat.json');
    const expectedCount = 0;

    it(`should return no tags to delete`, (done) => {
      migratortronApi.post(
        'delete/tags/commit?simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.tagsToMigrate.migratortron).to.be.an('object');
          expect(body.tagsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.tagsToMigrate.tagIds).to.be.an('object');

          expect(getTagIds(body.tagsToMigrate.tagIds)).to.have.a.lengthOf(
            expectedCount
          );

          expect(body.tagsResult.deleted).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe('preview delete tag groups with a query', () => {
    const mock = loadRecordedMock('delete_taggroups_q=group_preview.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${expectedCount} tag groups to delete`, (done) => {
      migratortronApi.post(
        'delete/taggroups?q=group',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.delete).to.equal(
            expectedCount
          );
          expect(body.groupsToMigrate.groupIds).to.be.an('object');
          expect(Object.keys(body.groupsToMigrate.groupIds)).to.have.a.lengthOf(
            expectedCount
          );

          expect(
            groupIdsWithStatus(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount);
          done();
        }
      );
    });
  });

  describe('delete tag groups with a query', () => {
    const mock = loadRecordedMock('delete_taggroups_commit_q=group.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${expectedCount} tag groups to delete`, (done) => {
      migratortronApi.post(
        'delete/taggroups/commit?q=group',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.delete).to.equal(
            expectedCount
          );
          expect(body.groupsToMigrate.groupIds).to.be.an('object');
          expect(Object.keys(body.groupsToMigrate.groupIds)).to.have.a.lengthOf(
            expectedCount
          );
          expect(
            groupIdsWithStatus(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount);

          expect(body.groupsResult.deleted).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe('repeat the same delete tag groups with a query', () => {
    const mock = loadRecordedMock(
      'delete_taggroups_commit_q=group_repeat.json'
    );
    const expectedCount = 0;

    it(`should return no tag groups to delete`, (done) => {
      migratortronApi.post(
        'delete/taggroups/commit?q=group&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(
            expectedCount
          );
          expect(body.groupsToMigrate.groupIds).to.be.an('object');
          expect(Object.keys(body.groupsToMigrate.groupIds)).to.have.a.lengthOf(
            expectedCount
          );

          expect(body.groupsResult.deleted).to.equal(expectedCount);
          done();
        }
      );
    });
  });

  describe('preview delete all tag groups in a project', () => {
    const mock = loadRecordedMock('delete_taggroups_simple_preview.json');
    const expectedCount = mock.response.existing.migratortron.totalCount;

    it(`should return ${expectedCount} tag groups to delete`, (done) => {
      migratortronApi.post(
        'delete/taggroups?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(expectedCount);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.delete).to.equal(
            expectedCount
          );
          expect(body.groupsToMigrate.groupIds).to.be.an('object');
          expect(Object.keys(body.groupsToMigrate.groupIds)).to.have.a.lengthOf(
            expectedCount
          );

          expect(
            groupIdsWithStatus(body.groupsToMigrate.groupIds)
          ).to.have.a.lengthOf(expectedCount);
          done();
        }
      );
    });
  });

  describe('delete all tag groups in a project', () => {
    const mock = loadRecordedMock('delete_taggroups_commit_simple.json');
    const expectedCount = mock.response.existing.migratortron.totalCount - 1;
    const errorCount = 1;

    it(`should return ${expectedCount} tag groups to delete`, (done) => {
      migratortronApi.post(
        'delete/taggroups/commit?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          // expect(body.errors).to.not.exist;
          expect(body.errors).to.be.an('array');
          expect(body.errors).to.have.a.lengthOf(errorCount);

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(
            expectedCount + errorCount
          );

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.delete).to.equal(
            expectedCount
          );
          expect(body.groupsToMigrate.groupIds).to.be.an('object');
          expect(Object.keys(body.groupsToMigrate.groupIds)).to.have.a.lengthOf(
            expectedCount + errorCount
          );
          expect(
            groupIdsWithStatus(body.groupsToMigrate.groupIds, 'delete')
          ).to.have.a.lengthOf(expectedCount);
          expect(
            groupIdsWithStatus(body.groupsToMigrate.groupIds, 'error')
          ).to.have.a.lengthOf(errorCount);

          expect(body.groupsResult.deleted).to.equal(expectedCount);
          expect(body.groupsResult.errors).to.equal(errorCount);
          done();
        }
      );
    });
  });

  describe('repeat the same delete all tag groups in a project', () => {
    const mock = loadRecordedMock('delete_taggroups_commit_simple_repeat.json');
    const expectedCount = 0;
    const errorCount = 1;

    it(`should return no tag groups to delete`, (done) => {
      migratortronApi.post(
        'delete/taggroups/commit?simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);
          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          // expect(body.errors).to.not.exist;
          expect(body.errors).to.be.an('array');
          expect(body.errors).to.have.a.lengthOf(errorCount);

          expect(body.committed).to.be.true;

          expect(body.existing).to.be.an('object');
          expect(body.existing.migratortron).to.be.an('object');
          expect(body.existing.migratortron.totalCount).to.equal(errorCount);

          expect(body.groupsToMigrate.migratortron).to.be.an('object');
          expect(body.groupsToMigrate.migratortron.error).to.equal(errorCount);
          expect(body.groupsToMigrate.migratortron.totalCount).to.equal(0);
          expect(body.groupsToMigrate.groupIds).to.be.an('object');
          expect(Object.keys(body.groupsToMigrate.groupIds)).to.have.a.lengthOf(
            errorCount
          );
          expect(
            groupIdsWithStatus(body.groupsToMigrate.groupIds, 'delete')
          ).to.have.a.lengthOf(expectedCount);
          expect(
            groupIdsWithStatus(body.groupsToMigrate.groupIds, 'error')
          ).to.have.a.lengthOf(errorCount);

          expect(body.groupsResult.deleted).to.equal(expectedCount);
          expect(body.groupsResult.errors).to.equal(errorCount);
          done();
        }
      );
    });
  });
});
